import React from "react";
import PropTypes from "prop-types";
import { EmptyScheduleContainer } from "./EmptySchedule.style";

const EmptySchedule = ({ title, description, icon }) => {
  return (
    <EmptyScheduleContainer className="class-schedule-empty">
      <div className="empty-icon-wrapper">
        {icon || (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
            <line x1="3" y1="3" x2="21" y2="21" />
          </svg>
        )}
      </div>
      <h3 className="empty-title">{title}</h3>
      <p className="empty-description">{description}</p>
    </EmptyScheduleContainer>
  );
};

EmptySchedule.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  icon: PropTypes.node,
};

EmptySchedule.defaultProps = {
  title: "Sin horarios disponibles",
  description: "No hay clases programadas para esta fecha. Intenta seleccionando otro día en el calendario.",
};

export default EmptySchedule;
